// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3_ccu","consentsList":"PatientConsents_consentsList__15NfQ","consentsListEmpty":"PatientConsents_consentsListEmpty__3ikSI"};